module.exports = __webpack_public_path__ + "img/dne-market.7ac8fa40.svg";